<script>
import ImageAssetEmbed from '@/components/shared/ImageAssetEmbed';
import VideoAssetEmbed from '@/components/shared/VideoAssetEmbed';

import { h } from 'vue';

export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  computed: {
    component() {
      if (this.asset.contentType?.includes('image')) {
        return ImageAssetEmbed;
      } else if (this.asset.contentType?.includes('video')) {
        return VideoAssetEmbed;
      } else {
        throw new Error('Asset component not found.');
      }
    }
  },
  render() {
    return h(this.component, { asset: this.asset });
  }
};
</script>
